import { Grid, Typography } from '@mui/material'
import React from 'react'



const Astrict = () => {
    return (
        <>
            <Typography component={'span'} sx={{ color: "#ec6565" }}>*</Typography>
        </>
    )
}

export default Astrict